import { checkToken } from '@/api/setting'
import { OK_CODE } from '@/api/setting/config'
import { mapMutations, mapActions } from 'vuex'

export default {
  methods: {
    ...mapMutations(['setMobile', 'setLmid', 'setMobilePrefix']),
    ...mapActions(['cleanSavedData'])
  },
  created() {
    if (this.isCheckToken) { // 如果开启了token 效验
      checkToken().then(res => {
        if (res.code === OK_CODE) {
          const data = res.data || {}
          data.mobile && this.setMobile(data.mobile)
          data.lmid && this.setLmid(data.lmid)
          data.prefix && this.setMobilePrefix(data.prefix)
        } else {
          // todo 如果code 不是 0000，直接登出
          this.cleanSavedData()
        }
      }).catch(() => {
        // console.log(err)
      })
    }
  },
  computed: {
    isCheckToken() {
      return this.$route.meta.checkToken
    }
  }
}
